<template>
  <transition name="menu-animation">
    <div v-show="viaibled" class="menu">
      <div v-if="viaibled" class="menu-container">
        <div v-for="(item, index) in menuData" :key="index" class="inner">
          <a :href="item.url">
            {{ isInI18n ? $t(item.name) : item.name }}
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  props: {
    viaibled: {
      type: Boolean,
      default: true
    },
    menuData: {
      type: Array,
      default: () => []
    },
    isInI18n: {
      type: Boolean,
      default: false
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.menu {
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 98;
  background: #fff;
  text-align: center;
  &-container {
    padding-top: 100px;
    height: 100%;
    animation: fadeInTitle 0.5s;
    animation-timing-function: cubic-bezier(0.13, 0, 0.26, 1);
    animation-fill-mode: forwards;
  }
  .inner {
    width: 100%;
    line-height: 100px;
    font-size: 24px;
    a {
      display: inline-block;
      width: 100%;
      line-height: 100px;
      color: #000;
      text-decoration: none;
    }
  }
}

.menu-animation-enter-active {
  animation: 300ms cubic-bezier(0.33, 0, 0.67, 1) 0ms 1 normal none running menuAnimationEnter;
}

.menu-animation-leave-active {
  animation: menuAnimationLeave 0.3s cubic-bezier(0.33, 0, 0.67, 1);
}

@keyframes menuAnimationEnter {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 0.4;
    transform: translateY(0);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes menuAnimationLeave {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.pageTitleAni {
  animation: fadeInTitle 0.2s;
  animation-timing-function: cubic-bezier(0.13, 0, 0.26, 1);
  animation-fill-mode: forwards;
}
@keyframes fadeInTitle {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
